/**
 * Sidebar panel toggle icon — rounded square with left rail (VS Code–style panel).
 */
interface SidebarToggleIconProps {
  className?: string;
}

export function SidebarToggleIcon({ className = 'w-5 h-5' }: SidebarToggleIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <rect x="3.5" y="4.5" width="17" height="15" rx="3" />
      <line x1="9" y1="4.5" x2="9" y2="19.5" />
    </svg>
  );
}
